import { motion, Variants } from 'framer-motion';
import React, { ReactNode, useState } from 'react';
import { useTranslation } from 'react-i18next';

export default function Box(props: { title: string; content: ReactNode; icon: ReactNode }) {
    const [hover, setHover] = useState<boolean>(false);

    const { t } = useTranslation();

    const VContent = {
        hover: {
            y: '0',
        },
        initial: {
            y: '100%',
        },
    } as Variants;

    return (
        <motion.div
            onMouseEnter={() => setHover(true)}
            onMouseLeave={() => setHover(false)}
            animate={hover ? 'hover' : 'initial'}
            initial={'initial'}
            className={
                'box-shadow relative basis-full overflow-hidden bg-white py-24 lg:basis-[49%] xl:basis-[31%]'
            }>
            <div className={'flex h-full flex-col items-center justify-center px-5'}>
                <div className={'rounded-full bg-white text-6xl text-SM-yellow'}>{props.icon}</div>
                <h4 className={'mb-4 text-center font-medium'}>{props.title}</h4>
                <small className={'absolute bottom-2 text-gray-500'}>
                    {t('translation:MAIN_PAGE.FAQ.HOVER')}
                </small>
            </div>

            <motion.div
                variants={VContent}
                transition={{ duration: 0.5 }}
                className={
                    'absolute top-0 flex h-full flex-col justify-center bg-gray-50 px-10 py-10 text-center'
                }>
                <h4 className={'text-center font-medium'}>{props.title}</h4>
                <hr className={'mt-1 mb-3 h-1 rounded-full bg-SM-yellow'} />
                <p>{props.content}</p>
            </motion.div>
        </motion.div>
    );
}
